import { CampaignType } from '../../../../constants/marketingCampaign'
import { BuildFormValuesContext } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { BogoSameRuleState } from './types'

export function buildBogoSameFormValues(
	ctx: BuildFormValuesContext<BogoSameRuleState>,
): Record<string, unknown> {
	const { rule, confirmation, selectedShopIds, campaignMeta, marketingCampaignKey } = ctx
	const base: Record<string, unknown> = {
		startDate: confirmation.startDate,
		startTime: confirmation.startTime,
		discount: null,
		threshold: null,
		type: CampaignType.BUY_ONE_GET_ONE_PRODUCT,
		shopIds: selectedShopIds,
		valueType: campaignMeta.valueType,
		products: rule.products,
		hasLimit: confirmation.hasLimit,
		limit: confirmation.hasLimit ? confirmation.limit : null,
		marketingCampaignKey,
		orderTypes: confirmation.orderTypes,
		isPermanent: confirmation.isPermanent,
	}

	if (!confirmation.isPermanent) {
		base.endDate = confirmation.endDate
		base.endTime = confirmation.endTime
	}

	return base
}
